export type Locale = "vi" | "en";

export const LOCALES: Locale[] = ["vi", "en"];
export const DEFAULT_LOCALE: Locale = "vi";

export const LOCALE_LABELS: Record<Locale, string> = {
    vi: "Tiếng Việt",
    en: "English",
};

export const LOCALE_FLAGS: Record<Locale, string> = {
    vi: "🇻🇳",
    en: "🇺🇸",
};

export function isValidLocale(value: string): value is Locale {
    return LOCALES.includes(value as Locale);
}
